import React from 'react';
import { Illustration } from '@checkout-web/react-core';
import { ReactComponent as Sad } from '@resurs/tron/dist/illustrations/sad.svg';
import ErrorMessage from './ErrorMessage';
import { useTranslation } from 'react-i18next';

function NotFound() {
  const { t } = useTranslation();
  return (
    <ErrorMessage
      title={t('error.notFound_title')}
      message={t('error.notFound_message')}
      icon={<Illustration SVGIcon={Sad} size="lg" color="danger" />}
    />
  );
}

export default NotFound;
